module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-ir-highlights-aa2b07d8777225b8bfc78d5c8ca68ad9.svg";